<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-3 text-center"
  >
    <img
      src="@base-shared/assets/images/drawings-no-products-placeholder.svg"
      class="w-[212px] h-[237px] self-center"
      alt=""
      aria-hidden="true"
    >
    <span class="text-sm font-semibold text-gray-600 dark:text-white">
      {{ title }}
    </span>
    <slot />
  </div>
</template>
